import { useLocationMonitoringSchedule } from '@hakimo-ui/hakimo/data-access';
import { useEffect, useMemo, useState } from 'react';
import { DayLocationMonitoringConfig } from '../sop-workflow/util';
import {
  getCurrentMonitoringWindow,
  getTodaysMonitoringConfig,
  getTomorrowsMonitoringConfig,
} from './util';

interface Props {
  locationId: number;
}

export function MonitoringWindowInfo(props: Props) {
  const { locationId } = props;
  const [todayTommMonitoringConfig, setTodayTommMonitoringConfig] =
    useState<DayLocationMonitoringConfig[]>();

  const { data } = useLocationMonitoringSchedule(locationId);

  useEffect(() => {
    if (data) {
      const motionDetectionWindow = data.motionDetectionWindow;
      const todayMonitoringConfig = getTodaysMonitoringConfig(
        motionDetectionWindow
      );
      const tommorowMonitoringConfig = getTomorrowsMonitoringConfig(
        motionDetectionWindow
      );
      setTodayTommMonitoringConfig([
        todayMonitoringConfig,
        tommorowMonitoringConfig,
      ]);
    }
  }, [data]);

  const info = useMemo(() => {
    if (!todayTommMonitoringConfig) {
      return '';
    }
    return getCurrentMonitoringWindow(
      todayTommMonitoringConfig[0],
      todayTommMonitoringConfig[1]
    );
  }, [todayTommMonitoringConfig]);

  return info;
}

export default MonitoringWindowInfo;
